import React, { createContext, useContext, useState } from "react";

const LocalSettingsContext = createContext();

export function LocalSettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  return (
    <LocalSettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </LocalSettingsContext.Provider>
  );
}

export function useLocalSettings() {
  return useContext(LocalSettingsContext);
}
